import SpriteSymbol from "../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-empty",
  "use": "icon-empty-usage",
  "viewBox": "0 0 100 100",
  "content": "<symbol viewBox=\"0 0 100 100\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-empty\">\n<path d=\"M82.25 56.3158V89.25H16.75V15.2632V15.2632L16.7501 10.75H70.6779L76.4561 16.8324L76.9999 16.3158L76.4561 16.8324L82.25 22.931V56.1579V56.3158Z\" fill=\"white\" stroke=\"#EDF0F7\" stroke-width=\"1.5\" />\n<path d=\"M29 26H59V31H29V26Z\" fill=\"#EDF0F7\" />\n<path d=\"M29 54H45V59H29V54Z\" fill=\"#EDF0F7\" />\n<path d=\"M29 40H68V45H29V40Z\" fill=\"#EDF0F7\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol